import { render, staticRenderFns } from "./InProcessingClassDetailsPage.vue?vue&type=template&id=30469815&"
import script from "./InProcessingClassDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./InProcessingClassDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30469815')) {
      api.createRecord('30469815', component.options)
    } else {
      api.reload('30469815', component.options)
    }
    module.hot.accept("./InProcessingClassDetailsPage.vue?vue&type=template&id=30469815&", function () {
      api.rerender('30469815', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/340th/Student/InProcessingClassDetailsPage.vue"
export default component.exports